/** Numbered install steps, shared by the landing section and the install page. */
export function StepList({ steps }: { steps: string[] }) {
  return (
    <ol className="space-y-3">
      {steps.map((step, index) => (
        <li key={index} className="flex gap-3">
          <span
            aria-hidden="true"
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-semibold text-white"
          >
            {index + 1}
          </span>
          <span className="text-sm leading-6 text-gray-700">{step}</span>
        </li>
      ))}
    </ol>
  );
}
